/**
 * Created by USER on 2018/11/7.
 */
import {
  GET_ANNOUNCEMENT,
  GET_SINGLE_ANNOUNCEMENT
} from '../actions/announcement_action';

const initState = {
  announcement: {
    data: []
  },
  singleAnnouncement: {
    title: '',
    author_name: '',
    date_updated: '',
    category_name: ''
  }
};

export default function announcementReducer(state = initState, action) {
  switch (action.type) {
    case GET_ANNOUNCEMENT:
      return Object.assign({}, state, { announcement: action.data});
    case GET_SINGLE_ANNOUNCEMENT:
      return Object.assign({}, state, { singleAnnouncement: action.data});
    default:
      return state;
  }
}